module.exports = __webpack_public_path__ + "static/media/from-device-grey.c06cdb63.svg";